import { Position } from "@/types/battle";

export const roundedPositionOf = (position: Position) => {
  return {
    x: Math.round(position.x),
    y: Math.round(position.y),
  };
};
